import { COLUMN_DEFINITIONS } from "./PorAsinListTable-config";
import {
  FullAsinWithAudits,
  RestrictedAsin,
} from "../../server/asin-central/model";
import { AuthorizedAttribute } from "../../server/brass/model";
import React, { ReactNode } from "react";
import { Input, TableProps } from "@amzn/awsui-components-react/polaris";
import { EditDatePicker, EditTextInput } from "./asinListEdit";

const editingColumns: any = {
  announceDate: {
    id: "announceDate",
    header: (
      <EditDatePicker
        id={"announceDate"}
        isHeader={true}
        placeholder={"Announce Date"}
      />
    ),
    cell: (item: FullAsinWithAudits | RestrictedAsin): ReactNode =>
      item.isRestricted ? (
        "-"
      ) : (
        <EditDatePicker id={"announceDate"} item={item} />
      ),
    minWidth: 220,
  },
  onlineStreetDate: {
    id: "onlineStreetDate",
    header: (
      <EditDatePicker
        id={"onlineStreetDate"}
        isHeader={true}
        placeholder={"Online Street Date"}
      />
    ),
    cell: (item: FullAsinWithAudits | RestrictedAsin): ReactNode =>
      item.isRestricted ? (
        "-"
      ) : (
        <EditDatePicker id={"onlineStreetDate"} item={item} />
      ),
    minWidth: 220,
  },
  userDescription: {
    id: "userDescription",
    header: (
      <EditTextInput
        id={"userDescription"}
        isHeader={true}
        placeholder={"User Description"}
      />
    ),
    cell: (item: FullAsinWithAudits | RestrictedAsin): ReactNode =>
      item.isRestricted ? (
        "-"
      ) : (
        <EditTextInput id={"userDescription"} item={item} />
      ),
    minWidth: 220,
  },
};

export const getEditColumnDefs = (
  editableAttributes: AuthorizedAttribute[]
): TableProps.ColumnDefinition<FullAsinWithAudits | RestrictedAsin>[] => {
  return COLUMN_DEFINITIONS.map((c: any) => {
    const canEdit =
      editableAttributes.filter(
        (attribute) => attribute.authorized && attribute.attributeName === c.id
      ).length > 0;
    if (canEdit) {
      return editingColumns[c.id] || c;
    }
    return c;
  });
};
